import { Button } from '@wot/components';
import { CheckCircle, User } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import heroimg from '../../assets/images/hero.webp'
import heromobile from '../../assets/images/hero2.webp'
interface Props{
  icon:any,
  title:string,
  subTitle:string,
  clazz:string
}

const LandingMain2 = () => {
  const [isDesktop, setIsDesktop] = useState(false);
  
  useEffect(() => {
    const checkScreen = () => setIsDesktop(window.innerWidth >= 1024);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);
  const navigate = useNavigate();
    return (
      <section className="relative bg-cover  bg-bottom min-h-[calc(100vh-60px)]"  style={{ backgroundImage: isDesktop ? `url(${heroimg})` : `url(${heromobile})` }}> 
          <div className='container mx-auto mt-8 lg:mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center relative py-20'>
              <div className='flex flex-col justify-center h-full'>
              <h1 className='text-2xl md:text-4xl xl:text-6xl lg:text-5xl font-extrabold max-w-2xl lg:max-w-3xl capitalize'> 
             Join Live and <br/>
                <span className='bg-gradient-to-r pr-2 from-secondary to-primary bg-clip-text text-transparent [-webkit-text-fill-color:transparent]'> Interactive Online Classes</span>
                  With the best Tutor
               </h1>
               {/* <p className='py-8 text-lg md:text-xl '>Join thousands of students worldwide learning with top-rated online teachers in
                 the USA, UK, Canada & Australia. Start with a free 1:1 demo class today!
                 </p> */}
                
                <div className='text-lg font-medium text-white flex flex-wrap items-center text-nowrap md:gap-x-8 gap-4 py-8'>

                 <Button text="Book Your Free Demo Class" className='w-full' size="lg" onClick={()=>{navigate('/booktrail')}}  />
                 <Button text="Explore Subject`s Tutor" className='!bg-primary w-full !border-primary ' size="lg" onClick={()=>{navigate('/find-tutor')}}  />
                </div>

                <div className='pb-5 flex lg:gap-x-16 gap-x-4 gay-y-2 flex-wrap  '>
                <ListComp icon={<User/>} title={'10,000+'} subTitle='Students taught' clazz='bg-secondary text-white'/>
                <ListComp icon={<User/>} title={'Certified Tutors'} subTitle='6+ Years Experience' clazz='bg-primary text-white'/>
                </div>
              </div>
          <div className="relative">
          {/* <div className="bg-white/40 backdrop-blur-md rounded-2xl p-2 shadow-lg border border-gray-200/80">
         
            <div className=" aspect-video bg-blue-600 rounded-lg flex items-center justify-center">
 
              <img src={""} alt={""} className="w-full h-full object-cover"/>
            </div>
          </div> */}
        </div>
          </div>

     </section>
  );
};


const ListComp = ({icon,title,subTitle, clazz}:Props) =>{
      return( <div className='flex gap-2 items-center py-4'>
        <div className={`p-1.5 rounded-full  ${clazz}`}>
           <CheckCircle size={22}/>
        </div>
            <div>
                  <div className='flex gap-1 items-center'>
                  <span className=''>
                {icon}
                 </span>
                 <span className='text-xl font-bold'>
                     {title}
                 </span>
                  </div>
                  <p className='text-sm text-gray-500 pt-1'>{subTitle}</p>
            </div>
       </div>)
}
export default LandingMain2;